import React from 'react';
import PropTypes from 'prop-types';
import { serializeClasses } from 'utilities/css';
import { useImageLoader } from 'hooks/useImageLoader';
import { Avatar as ImageAvatar } from '@mui/material';
import FallbackAvatar from './fallbackAvatar';

const Avatar = ({
  avatarUrl, size, name, showBorder, shape, className, ...rest
}) => {
  const imageFound = useImageLoader(avatarUrl);

  const classes = serializeClasses([shape, className, showBorder && 'showBorder']);

  const AvatarComponent = imageFound ? ImageAvatar : FallbackAvatar;

  return (
    <AvatarComponent
      {...rest}
      src={avatarUrl}
      size={size}
      alt={name}
      className={classes}
      sx={{ height: size, width: size }}
      slotProps={{
        img: {
          loading: 'lazy',
        },
      }}
    />
  );
};

Avatar.propTypes = {
  avatarUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  showBorder: PropTypes.bool,
  shape: PropTypes.oneOf(['circle', 'square']),
  className: PropTypes.string,
};

Avatar.defaultProps = {
  size: '24px',
  showBorder: false,
  avatarUrl: undefined,
  shape: 'circle',
  className: undefined
};

export default Avatar;
